export default "__VITE_ASSET__d116e159__"